import { IconSvg } from '../types'

export const BemloIcon: IconSvg = (props) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 408 408"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M165.423 408C146.645 408 131.423 392.778 131.423 374V276.577H34C15.2223 276.577 0 261.355 0 242.577V165.423C0 146.645 15.2223 131.423 34 131.423H131.423V34C131.423 15.2223 146.645 0 165.423 0H242.577C261.355 0 276.577 15.2223 276.577 34V131.423H374C392.778 131.423 408 146.645 408 165.423V242.577C408 261.355 392.778 276.577 374 276.577H276.578L276.577 131.423L131.423 131.423L131.425 347.194L192.082 286.537C198.458 280.161 207.106 276.578 216.123 276.578L276.578 276.577L276.577 374C276.577 392.778 261.355 408 242.577 408H165.423Z"
      />
    </svg>
  )
}
